import React from "react";
import TiptapEditor from "../editor/TipTapEditor";

const TextSettings = ({ content, onUpdate }) => {
  return <TiptapEditor content={content} onUpdate={onUpdate} />;
};

export default TextSettings;
